// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ymo8","placeholdersHeader":"styles_placeholdersHeader__3mvUk","editorStyle":"styles_editorStyle__2axEg","placeholdersBox":"styles_placeholdersBox__2mm_M"};